<template>
  <div class="main-feed mt-5">
    <div>
      <v-row class="ma-0">
        <h2>Pending Kennel Registrations</h2>
      </v-row>
    </div>
    <v-data-table 
      :loading="loading"
      :headers="headers"
      :options.sync="options"
      :items="paginatedResponse.data"
      :server-items-length="paginatedResponse.totalCount"
      :search="search"
      :footer-props="footerProps">
        <template v-slot:item.requestId="{ item }">
          <router-link :to="`/requests/KennelRegistration/${item.workflowGuid}`" target="_blank">{{
            item.requestId
          }}</router-link>
        </template>
        <template v-slot:item.submittedAt="{ item }">
          <span>{{ $dateUtils.formatDateTime(new Date(item.submittedAt)) }}</span>
        </template>
    </v-data-table>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import { UserInfo } from "@/types/User";
import { PaginationOptions, PaginatedResponse } from "@/types/Pagination";
import workflowService from '@/services/portal/workflowService';

export default Vue.extend({
  name: "KennelRegistrationList",
  props: {
    readyToApproveOnly: String,
  },
  data: function () {
    return {
      loading: false,
      paginatedResponse: {} as PaginatedResponse<object>,
      menu: false,
      search: '',
      options: {} as PaginationOptions,
      headers: [
        { text: "#ID", align: "left", value: "requestId" },
        { text: "Submitted at", align: "left", value: "submittedAt" },
        { text: "Status", align: "left", value: "status" },
        { text: "First Name Choice", align: "left", value: "firstName", sortable: false },
        { text: "Second Name Choice", align: "left", value: "secondName", sortable: false },
      ],
      footerProps: { 'items-per-page-options': [10, 20, 30, 40, 50] }
    };
  },
  created() { this.loadList(); },
  watch: {
    options: {
      handler() {
        this.loadList();
      },
      deep: true,
    }
  },
  methods: {
    applyFilters: function () {
      this.menu = false;
      this.loadList();
    },
    loadList: async function () {
      this.loading = true;
      const {
        page,
        itemsPerPage,
      } = this.options;

      const response = await workflowService.getKennelRegistrationRequests({
        ...this.options,
        page: (page ?? 1) - 1,
        itemsPerPage: itemsPerPage ?? 10
      });

      this.loading = false;
      this.paginatedResponse = response;
    }
  },
  computed: {
    userInfo(): UserInfo {
      return this.$store.state.userInfo;
    },
  },
});
</script>
